import React, { FC, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { logout } from '../../../actions/userProfileActions';
import { ReactComponent as IconLogout } from '../../../icons/logout.svg';
// import { ReactComponent as IconMail } from '../../../icons/package.svg';
import { fetchRefunds } from '../../../actions/refundsActions';
import { firstName } from '../../../helpers/stringHelpers/stringHelpers';
import { ReactComponent as IconMail } from '../../../icons/parcel.svg';
import { ReactComponent as IconPencil } from '../../../icons/pencil.svg';
import { ReactComponent as IconAddressBook } from '../../../icons/people.svg';
import { ReactComponent as IconUser } from '../../../icons/user.svg';
import IMyShipmentsViewModel from '../../../interfaces/myShipments/myShipments';
import ISettingsViewModel from '../../../interfaces/umbracoNodes/settingsViewModel';
import { RootState } from '../../../store';
import * as StyledMenu from './menu.styles';

interface Props {
	page: IMyShipmentsViewModel;
}

const Menu: FC<Props> = () => {
	const { t } = useTranslation('myShipments');
	const dispatch = useDispatch<any>();
	const { userProfileReducer, pageReducer, refundsReducer } = useSelector((store: RootState) => store);
	const { userProfile } = userProfileReducer;
	const { refund } = refundsReducer;
	// @ts-ignore
	const settingsPage: ISettingsViewModel = pageReducer.settings;
	useEffect(() => {
		// Get data from API
		dispatch(fetchRefunds());
	}, [dispatch, userProfile.userId]);

	const refundUrl = userProfile.language === 'IS' ? '/minar-sidur/endurgreidsla/' : '/en/my-account/refund/';

	return (
		<>
			<StyledMenu.Heading>
				<span>{t('navigation.welcome')}</span>
				{firstName(userProfile.name)}
			</StyledMenu.Heading>
			<StyledMenu.Navigation>
				<StyledMenu.LinkWrapper>
					<StyledMenu.Option exact to={settingsPage.Values.MyShipmentsLink.Url} activeClassName="active">
						<IconMail />
						<div>{t('shipments')}</div>
					</StyledMenu.Option>
					<StyledMenu.Option
						exact
						to={settingsPage.Values?.MyRegisterShipmentLink?.Url}
						activeClassName="active">
						<IconPencil />
						<div>{t('navigation.register-shipment')}</div>
					</StyledMenu.Option>
					<StyledMenu.Option exact to={settingsPage.Values.Settings.Url} activeClassName="active">
						<IconUser />
						<div>{t('navigation.settings')}</div>
					</StyledMenu.Option>
					<StyledMenu.Option exact to={settingsPage.Values.Recipients.Url} activeClassName="active">
						<IconAddressBook />
						<div>{t('navigation.recipients')}</div>
					</StyledMenu.Option>
					{/* regular user will not see this option */}
					{refund && refund.totalAmount !== 0 && (
						<StyledMenu.Option exact to={refundUrl} activeClassName="active">
							<IconAddressBook />
							<div>{t('navigation.refund')}</div>
						</StyledMenu.Option>
					)}
					<StyledMenu.Logout onClick={() => dispatch(logout())}>
						<IconLogout />
						<div>{t('navigation.logout')}</div>
					</StyledMenu.Logout>
				</StyledMenu.LinkWrapper>
			</StyledMenu.Navigation>
		</>
	);
};

export default Menu;
